"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clearBlocks_1 = require("./clearBlocks");
function clearBlock(block, clearAd = true) {
    if (block.locked) {
        return Object.assign({}, block);
    }
    const newBlock = Object.assign(Object.assign({}, block), { childBlocks: clearBlocks_1.clearBlocks(block.childBlocks || []), contentFeed: null, contentFieldKey: null, contentItem: null, contentSlotNumber: null, contentStr: '' });
    if (clearAd) {
        return Object.assign(Object.assign({}, newBlock), { ad: null });
    }
    return Object.assign({}, newBlock);
}
exports.clearBlock = clearBlock;
//# sourceMappingURL=clearBlock.js.map